/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Kompozice`
};

const da_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Ssammensætning`
};

const de_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Zusammensetzung`
};

const en_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Composition`
};

const es_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Composición`
};

const fr_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Composition`
};

const hu_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Összetétel`
};

const it_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Composizione`
};

const nl_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Samenstelling`
};

const pl_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Kompozycja`
};

const pt_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Composição`
};

const sv_attributes_composition = /** @type {(inputs: {}) => string} */ () => {
	return `Sammansättning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_composition = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_composition(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_composition", locale)
	if (locale === "cs") return cs_attributes_composition(inputs)
	if (locale === "da") return da_attributes_composition(inputs)
	if (locale === "de") return de_attributes_composition(inputs)
	if (locale === "en") return en_attributes_composition(inputs)
	if (locale === "es") return es_attributes_composition(inputs)
	if (locale === "fr") return fr_attributes_composition(inputs)
	if (locale === "hu") return hu_attributes_composition(inputs)
	if (locale === "it") return it_attributes_composition(inputs)
	if (locale === "nl") return nl_attributes_composition(inputs)
	if (locale === "pl") return pl_attributes_composition(inputs)
	if (locale === "pt") return pt_attributes_composition(inputs)
	return sv_attributes_composition(inputs)
};
export { attributes_composition as "attributes.composition" }